import React from "react";
import { HistoryToggleOff } from '@mui/icons-material/';

const SessionDurationInfo = () => {
    return (
        <div className="container-session-duration-info">
            <div className="content-session-duration-info">
                <span className="session-duration-info__text">
                    <HistoryToggleOff sx={{ marginRight: "10px" }} />
                    Inicio de Sesión.
                </span>

            </div>

        </div>
    )
};

export default SessionDurationInfo;